var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.items && _vm.items.length
    ? _c(
        "div",
        [
          _c("TitleBlock", {
            attrs: { text: _vm.titleText, link: _vm.searchLink },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row" },
            _vm._l(_vm.items, function (article, index) {
              return _c(
                "div",
                { key: article.uuid, staticClass: "column column--1-2" },
                [
                  _c("Article", {
                    attrs: {
                      title: article.title,
                      desc: index < 4 ? article.summary : null,
                      image: article.field_image,
                      date: article.publishDate,
                      tags: index < 4 ? article.tags : null,
                      link: article.url,
                      file:
                        article.file && article.file.length > 0
                          ? `${_vm.$config.baseURL}${article.file}`
                          : null,
                      size: index > 3 ? "small border" : null,
                      "has-access": _vm.hasAccess,
                      "filter-tags-by-vocabulary": _vm.filterTagsByVocabulary,
                    },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }